export const cognitoConfig = {
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || process.env.REACT_APP_USER_POOL_ID || "ap-south-1_Lo9Xmmy3W",
  userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || process.env.REACT_APP_CLIENT_ID || "2ebk1l71j94ipks0b3vuoen615",
  cognitoDomain: process.env.REACT_APP_COGNITO_DOMAIN || "ap-south-1lo9xmmy3w.auth.ap-south-1.amazoncognito.com",
  redirectSignIn: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_IN || (typeof window !== "undefined" ? `${window.location.origin}/auth/callback` : "http://localhost:3000/auth/callback"),
  redirectSignOut: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_OUT || (typeof window !== "undefined" ? window.location.origin : "http://localhost:3000"),
  scopes: process.env.REACT_APP_COGNITO_SCOPES?.split(",") || [
    "openid",
    "email",
    "profile",
    "aws.cognito.signin.user.admin",
    "phone",
  ],
};
